import { useQuery } from "@apollo/client";
import { graphql } from "gql/apollo";
import { ImpactAgentFeedbackStatus } from "gql/apollo/graphql";
import { useHasFeature } from "ui-library/HasFeature";

export const CountImpactAgentFeedbacks = graphql(/* GraphQL */ `
	query CountImpactAgentFeedbacks($params: ListImpactAgentFeedbacksParams!) {
		countImpactAgentFeedbacks(params: $params)
	}
`);

interface Params {
	impactAgentId: string;
	feedbackStatus: ImpactAgentFeedbackStatus;
	isCorrection?: boolean;
}

export const useCountImpactAgentFeedbacks = ({
	impactAgentId,
	feedbackStatus,
	isCorrection,
}: Params) => {
	const hasFeedbackReview = useHasFeature("allow_impact_agent_feedback_review");

	const { data, loading, error } = useQuery(CountImpactAgentFeedbacks, {
		variables: {
			params: {
				impact_agent_id: impactAgentId,
				feedback_status: feedbackStatus,
				is_correction: isCorrection,
			},
		},
		skip: !impactAgentId || !hasFeedbackReview,
		fetchPolicy: "cache-and-network",
	});

	return {
		count: data?.countImpactAgentFeedbacks,
		loading,
		error,
	};
};
